import styled from 'styled-components'

import type { Trade } from '@root/entities/trade'
import type { ClassNameProps } from '@root/shared/react'

type TradeAmountCellProps = {
  value: Trade.Trade
} & ClassNameProps

const CHART_ALLOWED_TYPES = new Set(['buy', 'sell'])

export const TradeAmountChartCell: React.FC<TradeAmountCellProps> = ({
  value,
  className,
}) => {
  if (!CHART_ALLOWED_TYPES.has(value.type)) {
    return undefined
  }

  const percentageAdjusted = Math.min(Math.max(value.amountPercentage, 1), 100)

  return (
    <Root className={className}>
      <AmountBar
        style={{
          width: `${percentageAdjusted}%`,
        }}
        $type={value.type}
      />
    </Root>
  )
}

const Root = styled.div`
  position: absolute;
  left: 5px;

  width: 40%;
  height: 100%;
`

const AmountBar = styled.div<{ $type: Trade.Trade['type'] }>`
  background-image: ${({ $type }) => GRADIENT_MAP[$type]};

  height: 100%;
  background-position: start center;
  opacity: 1;

  font-size: 10px;
  font-weight: 500;
  color: var(--text-12);
`

const GRADIENT_MAP: Record<Trade.Trade['type'], string> = {
  buy: 'linear-gradient(90deg, rgba(var(--up-9-rgb), 0.05) 0%, rgba(var(--up-9-rgb), 0.13) 100%)',
  sell: 'linear-gradient(90deg, rgba(var(--down-9-rgb), 0.05) 0%, rgba(var(--down-9-rgb), 0.13) 100%)',

  poolInit:
    'linear-gradient(90deg, rgba(3, 152, 129, 0.3) 0%, rgba(3, 152, 129, 0.05) 100%)',
  liquidityAdd:
    'linear-gradient(90deg, rgba(3, 152, 129, 0.3) 0%, rgba(3, 152, 129, 0.05) 100%)',
  liquidityRemove:
    'linear-gradient(90deg, rgba(238, 53, 68, 0.3) 0%, rgba(238, 53, 68, 0.05) 100%)',
  poolMigrate:
    'linear-gradient(90deg, rgba(238, 53, 68, 0.3) 0%, rgba(238, 53, 68, 0.05) 100%)',
  quoteBurn: 'none',
  lpBurn: 'none',
}
